import { inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpErrorResponse,
  HttpInterceptorFn
} from '@angular/common/http';
import { Observable, throwError, from } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthService } from '@core/auth/auth.service';
import { environment } from '@env/environment';
import { getCleanCurrentUrl, hasAuthCallbackParams } from '@core/auth/auth-url.utils';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  if (!request.url.startsWith(environment.apiUrl)) {
    return next(request);
  }

  const authService = inject(AuthService);

  return from(authService.ensureValidToken()).pipe(
    switchMap(token => {
      if (!token) {
        if (!hasAuthCallbackParams()) {
          void authService.handleSessionExpired(getCleanCurrentUrl());
        }

        return throwError(() => new Error('No hay un token valido para llamar a la API.'));
      }

      const authReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      return next(authReq).pipe(
        catchError((error: HttpErrorResponse) => {
          console.error(`HTTP Error for ${request.url}`, error);

          if (error.status === 401) {
            void authService.handleSessionExpired(getCleanCurrentUrl());
          }

          if (error.status === 403) {
            // sin permisos: aca va toast / navegacion a pagina de acceso denegado
          }

          return throwError(() => error);
        })
      );
    })
  );
};
